import { useMemo } from "react";
import { useGetFilteredPacks } from "illuminate/hooks/usePacksAPI";
const useThreatRelatedIlluminatePacks = () => {
  const { filteredPacks: packs, loadingFilteredPacks: isInitialLoading } = useGetFilteredPacks({
    tags: ["attack"],
    include_deps: true
  });
  const notEnabledPacks = useMemo(() => packs.filter(({ enabled }) => !enabled), [packs]);
  return {
    isInitialLoading,
    allPacks: packs,
    notEnabledPacks
  };
};
export default useThreatRelatedIlluminatePacks;
